import type { guscio as it } from "../it/guscio.ts";

/** La cornice dell'interfaccia: barra, tema, accesso e componenti comuni. */
export const guscio: typeof it = {
  "nav.stack": "Stacks",
  "nav.porte": "Ports",
  "nav.attivita": "Activity",
  "nav.impostazioni": "Settings",
  "nav.esci": "Sign out",
  "nav.nonTrovata": "Page not found",
  "nav.tornaStack": "Back to stacks",
  "tema.acqua": "Aqua",
  "tema.indaco": "Indigo",
  "tema.ametista": "Amethyst",
  "tema.ambra": "Amber",
  "tema.colore": (p: { nome: string }) => `${p.nome} color`,
  "tema.chiaro": "Switch to light theme",
  "tema.scuro": "Switch to dark theme",
  "pannelli.ridimensiona": "Resize panels",
  "pannelli.suggerimento": "Drag to resize · double-click to reset",
  "accesso.titolo": "Sign in to Portman",
  "accesso.utente": "Username",
  "accesso.password": "Password",
  "accesso.entra": "Sign in",
  "primoAvvio.titolo": "Welcome to Portman",
  "primoAvvio.intro":
    "Create the administrator account. Only it can manage users and settings, and it can create more users later.",
  "primoAvvio.token": "Setup token",
  "primoAvvio.tokenAiuto":
    "You'll find it in Portman's startup logs, for example with docker compose logs portman. It proves you control the machine.",
  "primoAvvio.passwordAiuto": "At least 12 characters. A long passphrase is safer and easier to remember.",
  "primoAvvio.ripeti": "Repeat password",
  "primoAvvio.discordanti": "The passwords don't match.",
  "primoAvvio.crea": "Create administrator",
};
